import { FunctionComponent } from 'react';
import { LabelRowProps } from './types';

export const LabelRow: FunctionComponent<LabelRowProps> = (props) => (
  <tr className={props.className}>
    <td colSpan={1}>{props.children}</td>
    <td colSpan={9}></td>
  </tr>
);
